<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" class="ml-3">
        <span> {{ title }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            {{ title }}
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                  limpar();
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col>
              <ComboboxTerritoriosFases
                ref="fases"
                :value="territorioIniciativa"
                :rules="[required]"
                outlined
                :disabled="readonly"
              ></ComboboxTerritoriosFases>
            </v-col>
            <v-col>
              <ComboboxTerritoriosCategorias
                :value="territorioIniciativa"
                ref="categorias"
                :rules="[required]"
                outlined
                :territorioFaseId="territorioIniciativa.territorioFaseId"
                :disabled="readonly || !territorioIniciativa.territorioFaseId"
              ></ComboboxTerritoriosCategorias>
            </v-col>
          </v-row>
          <v-row
            v-if="
              territorioIniciativa.territorioCategoria &&
              territorioIniciativa.territorioFaseId
            "
          >
            <v-col>
              <template>
                <v-row>
                  <v-col>
                    <v-text-field
                      label="Nome da Iniciativa"
                      name="tipo"
                      type="text"
                      v-model="territorioIniciativa.nomeIniciativa"
                      required
                      outlined
                      :rules="[required]"
                      background-color="white"
                      hide-details="auto"
                      :disabled="readonly"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      label="Descrição detalhada"
                      name="tipo"
                      outlined
                      type="text"
                      v-model="territorioIniciativa.descricao"
                      :rules="[required]"
                      hide-details="auto"
                      background-color="white"
                      :disabled="readonly"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <div>
                      <v-text-field
                        v-model="territorioIniciativa.inicio"
                        v-mascara="'##/##/####'"
                        label="Data Início"
                        placeholder="00/00/0000"
                        outlined
                        hide-details="auto"
                        :rules="rulesData"
                        :disabled="readonly"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="territorioIniciativa.fim"
                      v-mascara="'##/##/####'"
                      label="Data Fim"
                      placeholder="00/00/0000"
                      outlined
                      hide-details="auto"
                      :rules="rulesData"
                      :disabled="readonly"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <div>
                      <ComboboxTerritoriosStatus
                        :value="territorioIniciativa"
                        outlined
                        :disabled="readonly"
                      ></ComboboxTerritoriosStatus>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <div>
                      Iniciativa implementada em todos os
                      {{ isGov ? "projetos" : "municípios" }} do Território?
                    </div>
                    <v-radio-group
                      v-model="territorioIniciativa.todos"
                      row
                      :disabled="readonly"
                      hide-details="auto"
                      :rules="[requiredBoolean]"
                      @change="
                        (e) => {
                          if (e) territorioIniciativa.excecao = null;
                        }
                      "
                    >
                      <v-radio label="Sim" :key="1" :value="true"></v-radio>
                      <v-radio label="Não" :key="2" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col>
                    <ComboboxMunicipioTerritoriosByTerritorios
                      :value="territorioIniciativa"
                      :multiple="true"
                      :territorioId="territorioId"
                      :disabled="
                        territorioIniciativa.todos ||
                        readonly ||
                        territorioIniciativa.todos == null
                      "
                      outlined
                      ref="iniciativaMunicipio"
                      :title="`Se NÃO, informar os ${
                        isGov ? 'projetos' : 'municípios'
                      } implementados`"
                      :rules="
                        territorioIniciativa.todos === false
                          ? [requiredArray]
                          : []
                      "
                    >
                    </ComboboxMunicipioTerritoriosByTerritorios>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <ComboboxTerritoriosReponsaveis
                      :filter="territorioIniciativa"
                      :disabled="readonly"
                    ></ComboboxTerritoriosReponsaveis>
                  </v-col>

                  <v-col>
                    <v-currency-field
                      label="Valor estimado total"
                      :prefix="'R$'"
                      outlined
                      hide-details="auto"
                      :disabled="readonly"
                      v-model="territorioIniciativa.custo"
                    />
                  </v-col>
                  <v-col>
                    <div>
                      <v-text-field
                        v-model="territorioIniciativa.atores"
                        label="Atores"
                        outlined
                        hide-details="auto"
                        :disabled="readonly"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>Iniciativa conta com envolvimento de Prefeitura?</div>
                    <v-radio-group
                      v-model="
                        territorioIniciativa.iniciativaContaEnvolvimentoPrefeitura
                      "
                      :disabled="readonly"
                      row
                      hide-details="auto"
                      :rules="[requiredBoolean]"
                    >
                      <v-radio label="Sim" :key="1" :value="true"></v-radio>
                      <v-radio label="Não" :key="2" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col>
                    <div>Iniciativa Própria?</div>
                    <v-radio-group
                      v-model="territorioIniciativa.propria"
                      row
                      :disabled="readonly"
                      hide-details="auto"
                      :rules="[requiredBoolean]"
                    >
                      <v-radio label="Sim" :key="1" :value="true"></v-radio>
                      <v-radio label="Não" :key="2" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      label="Justificativa/Observações de status"
                      v-model="territorioIniciativa.observacoes"
                      outlined
                      :disabled="readonly"
                      hide-details="auto"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>
              </template>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              dialog = false;
              limpar();
            }
          "
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm" v-if="!readonly"
          >Salvar rascunho</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxTerritoriosCategorias from "@/modules/gestao-territorios/components/categorias/ComboboxTerritoriosCategoriasByFase";
import ComboboxTerritoriosIniciativasByEixo from "@/modules/gestao-territorios/components/iniciativas/ComboboxTerritoriosIniciativasByEixo";
import { dataRegexValidatior } from "@/helpers/validator";
import ComboboxTerritoriosStatus from "@/modules/gestao-territorios/components/status/ComboboxTerritorioIniciativaStatus";
import ComboboxTerritoriosReponsaveis from "../responsaveis/ComboboxTerritoriosReponsaveis.vue";
import { required, requiredBoolean, requiredArray } from "@/helpers/validator";
import moment from "moment";
import ComboboxTerritoriosFases from "../fases/ComboboxTerritoriosFases.vue";
import ComboboxMunicipioTerritoriosByTerritorios from "./ComboboxMunicipioTerritoriosByTerritorios.vue";
import Swal from "sweetalert2";

export default {
  name: "ModalAdicionarIniciativa",
  components: {
    ComboboxTerritoriosCategorias,
    ComboboxTerritoriosIniciativasByEixo,
    ComboboxTerritoriosStatus,
    ComboboxTerritoriosReponsaveis,
    ComboboxTerritoriosFases,
    ComboboxMunicipioTerritoriosByTerritorios,
  },
  props: {
    territorioId: { type: String, required: true },
    filter: {},
    title: "",
    iniciativa: {},
    readonly: false,
    iniciativasSelecionadas: [],
    possuiMunicipio: { type: Boolean, required: false, default: false },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.territorioIniciativa = { responsaveis: [] };
        this.payload = {
          territorioCategoria: null,
          territorioIniciativa: [],
          territorioIniciativaId: [],
        };

        if (this.iniciativa) {
          this.territorioIniciativa = { ...this.iniciativa };
          console.log("this.territorioIniciativa ", this.territorioIniciativa);

          this.territorioIniciativa.todos =
            this.iniciativa.todos == 1 ? true : false;
          this.territorioIniciativa.inicio = moment(
            this.iniciativa.inicio,
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY");

          this.territorioIniciativa.fim = moment(
            this.iniciativa.fim,
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY");
        }
      }
      this.$forceUpdate();
    },
  },

  data() {
    return {
      territorioIniciativa: { responsaveis: [] },
      payload: {
        territorioCategoria: null,
        territorioIniciativa: [],
        territorioIniciativaId: [],
      },
      rulesData: [
        (v, item) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }

          return true;
        },
      ],
      requiredBoolean: requiredBoolean,
      required: required,
      requiredArray: requiredArray,
      dialog: false,
      valid: true,
      headers: [
        { text: "Nome", value: "nomeIniciativa" },
        { text: "Datas", value: "date" },
        { text: "Datas", value: "date" },
        { text: "Responsáveis", value: "responsaveis" },
        { text: "Custo", value: "custo" },
        { text: "Atores", value: "atores" },
        { text: "Status", value: "status" },

        { text: "Ação", value: "action", width: "10%" },
      ],
    };
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    limpar() {
      this.payload = { territorioIniciativa: [] };
      this.$forceUpdate();
    },

    async validate() {
      const valid = await this.$refs.form.validate();
      const validFase = await this.$refs.fases.check();

      const validCategoria = await this.$refs.categorias.check();
      const validIniciativaMunicipio =
        await this.$refs.iniciativaMunicipio.check();

      return valid && validFase && validCategoria && validIniciativaMunicipio;
    },
    async onConfirm() {
      const isValid = await this.validate();
      if (!isValid) {
        return;
      }

      if (!this.territorioIniciativa) {
        this.$notification.error(
          `Não é possivel salvar sem nenhuma iniciativa`
        );
        return;
      }

      Swal.fire({
        title: `Salvar rascunho da iniciativa`,
        text: `Você está salvando um rascunho da iniciativa. Para adicioná-la ao território, será necessário clicar em 'Finalizar' mais tarde.`,
        icon: "info",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Entendi",
      }).then((_) => {
        this.payload.territorioIniciativa = {
          ...this.territorioIniciativa,
          selection: false,
        };

        this.$emit("onSave", this.payload.territorioIniciativa);
        this.limpar();
        this.dialog = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.dates {
  column-gap: 20px;
}
</style>
